import { ZERO_UUID } from 'commons/constants/parse.js';

export const state = () => ({
    active_site_uuid: ZERO_UUID,
    sites: {},
});
